<template>
    <div class="pipeline-execution-graph">
        <svg :width="width" :height="height" role="img" aria-label="Pipeline execution graph">
            <line
                v-for="edge in edges"
                :key="edge.id"
                :x1="nodeCenter(edge.source).x"
                :y1="nodeCenter(edge.source).y"
                :x2="nodeCenter(edge.target).x"
                :y2="nodeCenter(edge.target).y"
                stroke="#94a3b8"
                stroke-width="2"
                :stroke-dasharray="edge.animated ? '6 4' : '0'"
            />
            <g v-for="node in nodes" :key="node.id">
                <rect
                    :x="node.position.x"
                    :y="node.position.y"
                    width="180"
                    height="56"
                    rx="8"
                    :fill="statusColor(node.data.status)"
                    stroke="#1e293b"
                />
                <text
                    :x="node.position.x + 12"
                    :y="node.position.y + 22"
                    fill="#0f172a"
                    font-size="13"
                    font-weight="600"
                >
                    {{ node.data.label }}
                </text>
                <text
                    :x="node.position.x + 12"
                    :y="node.position.y + 42"
                    fill="#334155"
                    font-size="11"
                >
                    {{ node.data.status }}
                </text>
            </g>
        </svg>
    </div>
</template>

<script setup>
import axios from 'axios';
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    graphEndpoint: {
        type: String,
        required: true,
    },
});

const nodes = ref([]);
const edges = ref([]);

const width = computed(() => {
    const maxX = nodes.value.reduce((max, node) => Math.max(max, node.position.x), 0);

    return Math.max(640, maxX + 240);
});

const height = computed(() => {
    const maxY = nodes.value.reduce((max, node) => Math.max(max, node.position.y), 0);

    return Math.max(320, maxY + 120);
});

onMounted(async () => {
    const { data } = await axios.get(props.graphEndpoint);
    nodes.value = data.nodes ?? [];
    edges.value = data.edges ?? [];
});

function nodeCenter(id) {
    const node = nodes.value.find((item) => item.id === id) ?? { position: { x: 0, y: 0 } };

    return {
        x: node.position.x + 90,
        y: node.position.y + 28,
    };
}

function statusColor(status) {
    switch (status) {
        case 'running':
            return '#fde68a';
        case 'done':
            return '#bbf7d0';
        case 'failed':
            return '#fecaca';
        default:
            return '#e2e8f0';
    }
}
</script>

<style scoped>
.pipeline-execution-graph {
    overflow: auto;
}
</style>
